import { render, staticRenderFns } from "./WorkIconCompanyAdd.vue?vue&type=template&id=488d4478"
import script from "./WorkIconCompanyAdd.vue?vue&type=script&lang=js"
export * from "./WorkIconCompanyAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports